import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProdutoMainComponent } from './produto-main/produto-main.component';
import { GlobalModule } from 'src/app/global/global.module';

@NgModule({
  declarations: [ProdutoMainComponent],
  imports: [CommonModule, GlobalModule],
})
export class ProdutoModule {}
